import { Component } from '@angular/core';

@Component({
  selector: 'app-guest',
  templateUrl: 'guest.component.html',
})
export class GuestLayoutComponent {
}
